/**
 * Markdown formatted (`.markdown`, components/plane-markdown.js) and the Write and Preview tabs of
 * <plane-markdown-input>, which renders in the light DOM of the page: a page that shows or edits
 * a persona adds these to its styles.
 */
import { css } from 'lit';

export const markdownStyles = css`
  plane-markdown-input {
    display: block;
  }

  .markdown {
    overflow-wrap: anywhere;
    line-height: var(--line-height-body);
  }

  .markdown > :first-child {
    margin-top: 0;
  }

  .markdown > :last-child {
    margin-bottom: 0;
  }

  .markdown p,
  .markdown ul,
  .markdown ol,
  .markdown pre,
  .markdown blockquote {
    margin: 0 0 var(--space-2);
  }

  /* Small headings: a persona sits in a card that has its own. */
  .markdown h1,
  .markdown h2,
  .markdown h3,
  .markdown h4,
  .markdown h5,
  .markdown h6 {
    display: block;
    margin: var(--space-3) 0 var(--space-1);
    padding: 0;
    border: 0;
    font-family: inherit;
    font-size: var(--font-size-ui);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-ui);
  }

  .markdown h1 {
    font-size: var(--font-size-lg);
  }

  .markdown h2 {
    font-size: var(--font-size-base);
  }

  .markdown ul,
  .markdown ol {
    padding-left: var(--list-indent);
  }

  .markdown li > p,
  .markdown li > ul,
  .markdown li > ol {
    margin: 0;
  }

  .markdown blockquote {
    padding-left: var(--space-3);
    border-left: var(--marker-width) solid var(--border);
    color: var(--text-muted);
  }

  .markdown pre {
    padding: var(--space-2) var(--space-3);
    background: var(--surface);
    white-space: pre-wrap;
  }

  .markdown hr {
    margin: var(--space-3) 0;
    border: 0;
    border-top: var(--border-width) solid var(--border);
  }

  .markdown-tabs {
    display: flex;
    margin-bottom: calc(var(--border-width) * -1);
  }

  .markdown-tabs button {
    position: relative;
    min-height: 0;
    padding: var(--button-padding-small);
    border-color: transparent;
    background: transparent;
    color: var(--text-muted);
    font-size: var(--font-size-md);
  }

  .markdown-tabs button[aria-selected='true'] {
    border-color: var(--border-strong);
    border-bottom-color: var(--surface-raised);
    background: var(--surface-raised);
    color: var(--text);
  }

  .markdown-tabs button:hover:not(:disabled) {
    border-color: var(--border-strong);
  }

  .markdown-tabs button[aria-selected='true']:hover:not(:disabled) {
    border-bottom-color: var(--surface-raised);
  }

  .markdown-preview {
    padding: var(--field-padding);
    border: var(--border-width) solid var(--border-strong);
    border-radius: var(--radius);
    background: var(--surface-raised);
  }
`;
